<template>
  <div class="shadow">
    <DebugMenu v-if="store.debug"/>

    <div class="row">
      <div class="col-12 col-lg-4 pr-lg-0">
        <!--        <img src="/imgs/flags/czc.png" alt=""/>
                <img src="@/assets/imgs/sksk.png" alt=""/>
                <img v-bind:src="flagCz" alt=""/>-->

        <LeftContentBlock/>
      </div>

      <div class="col-12 col-lg-8">
        <div>
          <StepOne/>
          <StepTwo/>
          <StepThree/>
        </div>
        <ThankYou/>
        <!--        <span v-on:click="this.store.sendGaEvent('test')">GA send</span>-->
      </div>
    </div>
  </div>
  <scroll-to-form-button/>
  <changesWereMadeModal/>
</template>

<script>

//import 'bootstrap';
import LeftContentBlock from "./LeftContentBlock.vue";
import DebugMenu from "@/components/DebugMenu.vue";
import StepOne from "./steps/StepOne.vue";
import StepTwo from "./steps/StepTwo.vue";
import {store} from "./store.js";
import {useI18n} from 'vue-i18n'
import {useLocaleProfile} from "@/composables/useLocaleProfile";
import jakeProducts from '../assets/product.json';
import Steps from "./others/StepsComponent/Steps.vue";
import StepThree from "./steps/StepThree.vue";
import ThankYou from "@/components/steps/ThankYou.vue";
import ScrollToFormButton from "@/components/others/scrollToFormButton.vue";
import changesWereMadeModal from "@/components/others/changesWereMadeModal.vue";

export default {
  name: "jakeTradeForm",
  components: {
    changesWereMadeModal,
    ScrollToFormButton,
    StepThree,
    Steps,
    StepOne,
    StepTwo,
    LeftContentBlock,
    ThankYou,
    DebugMenu
  },
  setup() {
    const {t, locale} = useI18n({
      inheritLocale: true,
      useScope: 'local'
    })
    const {profile} = useLocaleProfile()
    return {t, locale, profile}
  },
  data() {
    return {
      errors: [],
      store,


    }
  },
  methods: {

    sendGaEvent(label, event = 'tradeForm', category = 'form', action = 'click') {
      var ga = this.store.pushDataLayer({
        'event': event,
        'event_category': category,
        'event_action': action,
        'event_label': label
      });
      console.log(ga, 'GA event');
    },
    // druhy zivnosti produkty
    findProductForTypeTrade() {
      //console.log("find product for type trade");
      var druhy = this.store.products.filter(obj => {
        return this.store.form.druhyZivnostiCodes.indexOf(obj.code) !== -1;
      });
      if (druhy.length > 0) {
        druhy.forEach(d => {
          d.type = 'tradeType';
          if (d.code === 'ZU02') d.position = 1;
          else if (d.code === 'ZU03') d.position = 2;
          else if (d.code === 'ZU06') d.position = 3;
          else if (d.code === 'ZU04') d.position = 4;
          else if (d.code === 'OS01') d.position = 5;

          d.totalPriceWithVat = d.standardPrice * store.getVatForProduct(d);
          d.totalPriceWithoutVat = d.standardPrice;

          if (this.profile.pricing === 'standard') {
            d.totalPriceWithVat = d.standardPrice * store.getVatForProduct(d);
            d.totalPriceWithoutVat = d.standardPrice;
          } else {
            d.totalPriceWithVat = d.prices.find(price => price.currency.priceListName === this.store.form.priceListName).price * store.getVatForProduct(d);
            d.totalPriceWithoutVat = d.prices.find(price => price.currency.priceListName === this.store.form.priceListName).price;
          }

          d.totalPriceWithVatFilter = this.store.priceFilter(d.totalPriceWithVat)
          d.totalPriceWithoutVatFilter = this.store.priceFilter(d.totalPriceWithoutVat)
          this.store.form.druhyZivnostiProducts.push(d);
        })
        // serazeni zivnosti podle pozice
        this.store.form.druhyZivnostiProducts.sort((a, b) => {
          return a.position - b.position;
        });

      }
      // prizpusobeni produktu ZU01
    },

    findSeatsPrices() {
      var seats = this.store.products.filter(obj => {
        return this.store.form.seatsCodes.indexOf(obj.code) !== -1;
      });
      this.store.form.seatsProducts = seats;
//      console.log(seats);
      this.store.form.seatsProducts.forEach(item => {
        const tempCode = item.code.split('_')[0];
        item.type = 'seat';
        var yearAr = item.formYears = [];
        var yearsString = ['12', '24', '36', '48', '60'];

        yearsString.forEach(y => {
          if (y === '12') var prod = item;
          else {
            var prod = this.store.getProduct(tempCode + '_' + y);
          }
          if (prod !== undefined) {
            prod.months = y
            prod.codeForTran = item.code
            if (this.profile.pricing === 'standard') {
              let standardPrice = prod.standardPrice;
              let noSaleStandardPrice = prod.standardPrice;
              if (y === '12' && prod.firstYearWebDiscountPercent !== undefined) {
                standardPrice = standardPrice - standardPrice * (prod.firstYearWebDiscountPercent / 100);
              }
              prod.totalPriceWithVat = standardPrice * store.getVatForProduct(prod) * y;
              prod.totalPriceWithoutVat = standardPrice * y;
              prod.totalPriceWithoutVatNoSale = noSaleStandardPrice * y;
            } else {
              let price = prod.prices.find(price => price.currency.priceListName === this.store.form.priceListName).price;
              let priceNoSale = price;
              if (y === '12' && prod.firstYearWebDiscountPercent !== undefined) {
                price = price - price * (prod.firstYearWebDiscountPercent / 100);
              }
              prod.totalPriceWithVat = price * store.getVatForProduct(prod) * y;
              prod.totalPriceWithoutVat = price * y;
              prod.totalPriceWithoutVatNoSale = priceNoSale * y;
            }
            prod.totalPriceWithVatFilter = this.store.priceFilter(prod.totalPriceWithVat)
            prod.totalPriceWithoutVatFilter = this.store.priceFilter(prod.totalPriceWithoutVat)
            prod.totalPriceWithoutVatNoSaleFilter = this.store.priceFilter(prod.totalPriceWithoutVatNoSale)
            prod.type = 'seat';
            yearAr.push(prod);
          }


        })


      })

    },


  },
  computed: {},
  mounted() {
    // load products from json
    this.store.products = jakeProducts.items;
    this.findProductForTypeTrade();
    this.findSeatsPrices();

    // pridani zakladniho produktu pro zalozeni zivnosti do kosiku
    this.store.addProduct('OS01');
    this.store.addProduct('ZU01');

    // Debug přepínač jazyka v App.vue mění locale za běhu. V sestaveném balíčku
    // se locale nemění, takže se tenhle watch nikdy nespustí.
    // Přepočet stačí spustit znovu — ceny se zapisují přímo na produktové objekty
    // a košík na ně drží reference, takže se srovná sám.
    this.$watch('profile', (profile) => {
      this.store.applyProfile(profile);
      this.store.form.druhyZivnostiProducts = []; // findProductForTypeTrade do pole pushuje
      this.findProductForTypeTrade();
      this.findSeatsPrices();
    });


  }

}
</script>

